/** data-testid constants for the settings account section UI. */
export const SETTINGS_ACCOUNT_SECTION_TEST_ID = 'settings-account-section';
export const SETTINGS_DISPLAY_NAME_INPUT_TEST_ID = 'settings-display-name-input';
export const SETTINGS_DISPLAY_NAME_SAVE_TEST_ID = 'settings-display-name-save';
export const SETTINGS_MARKETING_OPT_IN_TEST_ID = 'settings-marketing-opt-in';
export const SETTINGS_ACCOUNT_DELETE_START_TEST_ID = 'settings-account-delete-start';
export const SETTINGS_ACCOUNT_DELETE_REAUTH_PASSWORD_TEST_ID =
  'settings-account-delete-reauth-password';
export const SETTINGS_ACCOUNT_DELETE_CONFIRM_INPUT_TEST_ID =
  'settings-account-delete-confirm-email';
export const SETTINGS_ACCOUNT_DELETE_CONFIRM_TEST_ID = 'settings-account-delete-confirm';
export const SETTINGS_LANGUAGE_SECTION_TEST_ID = 'settings-language-section';
export const SETTINGS_LANGUAGE_NL_TEST_ID = 'settings-language-nl';
export const SETTINGS_LANGUAGE_EN_TEST_ID = 'settings-language-en';
